module.exports = __webpack_public_path__ + "static/media/PCP Product Name.bab689a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cont/PCP Product Name.png
// module id = 1183
// module chunks = 0